import React from 'react';
import VerifiedIcon from '@mui/icons-material/Verified';
import { Container, styled } from '@mui/system';
import { Typography } from '@mui/material';

const StySubtitle = styled(Typography, { name: 'StySubtitle' })(
    ({ theme }) => ({
        color: theme.palette.primary.main,
        paddingLeft: '0.2rem !important',
        margin: 'auto 0 !important',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: '0.7rem',
        textAlign: 'right',
    }),
);

const StyTextBadge = ({ title }: { title: string }) => (
    <Container
        sx={{
            display: 'flex',
            justifyContent: 'right',
            paddingRight: '0 !important',
        }}
    >
        <VerifiedIcon
            sx={(theme) => ({
                color: theme.palette.primary.main,
                borderRadius: '50%',
            })}
        />
        <StySubtitle variant="body1">{title}</StySubtitle>
    </Container>
);

export default StyTextBadge;
